import { type ReactNode } from 'react';

import { useMeasuredBar } from '../measure';

/**
 * The buttons that finish a form, pinned to the bottom of the screen.
 *
 * The same object the regent's `.panel` is, generalised: on «Создать хор» the
 * form is 73px taller than a 375×667 phone, so «Создать» was under the fold on
 * arrival - and a form whose only button cannot be seen reads as a form with
 * nothing to press. The owner asked for it on every screen whose bottom is a
 * full-width button, on 2026-08-21.
 *
 * It measures itself rather than declaring a height the way `--panel` does: one
 * button, two, and a refusal above them are three different heights, and a
 * number in the stylesheet would be wrong for two of the three the day somebody
 * adds a sentence.
 *
 * The refusal belongs in here with them. It is about the tap, and left up in
 * the form it would be the one thing on the screen a person cannot see at the
 * moment they need it.
 */
export default function Dock({ children }: { children: ReactNode }) {
  // The height the page below has to keep clear. It measures rather than
  // declaring: one button, two, and a refusal above them are three different
  // heights, and a number in the stylesheet would be wrong for two of the three
  // the day somebody adds a sentence.
  const ref = useMeasuredBar('--dock');

  return (
    <div className="dock" ref={ref}>
      {children}
    </div>
  );
}
